import Signup from "../components/auth/signup_/index";
import Layout from "../components/layouts/allpagelayout";
export default function SignupPage() {
  return (
    <Layout>
      <Signup />
    </Layout>
  );
}